









































































































































import {Component, Ref, Vue} from "vue-property-decorator";
import {CallCenterUserItem, CallCenterUserItemImpl} from "@/store/user_management/callcenter_users/types";
import {Action, Getter} from "vuex-class";
import {InputWings, SelectWings} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {SelectWings, InputWings}})
export default class CallCenterUser extends Vue {
  @Ref("validator") validator: any;

  @Action("getCallCenterUserItem") actionGetItem: any;
  @Action("saveCallCenterUserItem") actionSaveItem: any;
  @Action("deleteCallCenterUserItem") actionDeleteItem: any;
  @Action("resetPasswordCallCenter") actionResetPassword: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("actionLog") actionLog: any;

  @Getter("timezonesList") timezonesList: any;

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {}

  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  defaultItem(): CallCenterUserItem {
    return new CallCenterUserItemImpl()
  }

  async created() {
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Call center user",
        object_name: this.item.name,
        addititional_info: getTranslatedParams({id: this.$route.params.id})
      }
      try {
        let data: CallCenterUserItem = await this.actionGetItem(this.$route.params.id)
        // если с сервера приходит null
        data.status = data.status ? 1 : 0;
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.actionLog(this.logObject);
      } catch(error) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
      this.partnersList = await this.actionGetPartners({name: this.item.partner});
    }
  }


  back(): void {
    this.$router.push('/user_management/callcenter_users/');
  }

  onSaveItem(): Promise<void> {
    return new Promise( async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return;
      }
      try {
        await this.actionSaveItem(this.item);
        await this.logChangeParams("success");
        await this.logChangePassword("success");
        this.itemSaved = this.item;
        resolve();
        this.back();
      } catch (err) {
        await this.logChangeParams("failed");
        await this.logChangePassword("failed");
        reject();
        notifyError(err);
      }
    });
  }

  async onDeleteItem() {
    if (!await notifyDelete()) return
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Removal",
        action_status: "success",
        object_type: "Call center user",
        object_name: this.item.name,
        addititional_info: getTranslatedParams({id: this.$route.params.id})
      }
      await this.actionDeleteItem(this.item);
      await this.actionLog(this.logObject);
      this.itemSaved = this.item;
      this.back();
    } catch (error) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  async logChangeParams (action_status: string) {
    const fieldsToCompare: Array<keyof CallCenterUserItem> = ['name', 'partner', 'email', 'status', 'timezone_id', 'is_check_pass'];
    const isEqualAll = fieldsToCompare.every(field => isEqual(this.item[field], this.itemSaved[field]));
    if (isEqualAll) return;
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: this.$route.params.id ? "Editing" : "Creation",
      action_status: action_status,
      object_type: "Call center user",
      object_name: this.item.name,
      addititional_info: getTranslatedParams({id: this.$route.params.id})
    }
    await this.actionLog(this.logObject);
  }

  async logChangePassword (action_status: string){
    if (!this.$route.params.id) return;
    if (!this.item.password) return;
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Password change",
      action_status: action_status,
      object_type: "Call center user",
      addititional_info: getTranslatedParams(this.item)
    }
    await this.actionLog(this.logObject);
  }

  async onResetPassword() {
    try {
      await this.actionResetPassword({email: this.item.email});
      this.back();
    } catch (error) {
      notifyError(error);
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  get status(): any {
    return this.item.status;
  }

  set status(value: any) {
    this.item.status = (value ? 1 : 0);
  }

  get show_messages_text(): any {
    return this.item.show_messages_text;
  }

  set show_messages_text(value: any) {
    this.item.show_messages_text = (value ? 1 : 0);
  }

  get is_check_pass(): any {
    return this.item.is_check_pass;
  }

  set is_check_pass(value: any) {
    this.item.is_check_pass = (value ? 1 : 0);
  }
};
